export default {"src":"/oferta/_next/static/media/tiktok.63f6ac00.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};